import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PrimaryProfile {
  Id: string | null | undefined;
  PartnerId: string | null | undefined;
  Email: string | null| undefined;
  FirstName: string | null| undefined;
  MiddleName?: string | null | undefined;
  LastName: string | null | undefined;
  Phone: string | null | undefined;
  Languages?: string[] | null | undefined;
  LegacyClient: boolean | null | undefined;
  EnrollmentSource: EnrollmentSource | null | undefined;
}

interface SpouseProfile {
  Id: string;
  ParentId: string;
  AccountId: string;
  Email: string;
  FirstName: string;
  LastName: string;
}

interface PartnerProfile {
  Id: string;
  Email: string;
  FirstName: string;
  LastName: string;
  Phone: string;
  ApplicationStatus: ApplicationStatus
  OrganizationId: string | null;
}

export enum ApplicationStatus {
  Approved = "Approved",
  Rejected = "Rejected",
  Pending = "Pending",
  Processing = "Processing",
}

export enum EnrollmentSource {
  Organic = "Organic",
  Referral = "Referral",
  Legacy = "Legacy",
}

interface ProfileStore {
  primaryProfile: PrimaryProfile | null;
  spouseProfile: SpouseProfile | null;
  partnerProfile: PartnerProfile | null;
  setPrimaryProfile: (newProfileObj: PrimaryProfile) => void;
  setSpouseProfile: (newProfileObj: SpouseProfile) => void;
  setPartnerProfile: (newProfileObj: PartnerProfile) => void;
  clearProfileStore: () => void;
  eConsent: boolean;
  setEConsent: (flag: boolean) => void;
}

export const useProfileStore = create<ProfileStore>()(
  persist(
    (set) => ({
      primaryProfile: null,
      spouseProfile: null,
      partnerProfile: null,
      eConsent: false,
      setPrimaryProfile: (newProfileObj) => set({ primaryProfile: newProfileObj }),
      setSpouseProfile: (newProfileObj) => set({ spouseProfile: newProfileObj }),
      setPartnerProfile: (newProfileObj) => set({ partnerProfile: newProfileObj }),
      setEConsent: (flag: boolean) => set({ eConsent: flag }),
      clearProfileStore: () => {
        set({
          primaryProfile: null,
          spouseProfile: null,
          partnerProfile: null,
        });
        localStorage.removeItem('ProfileStore');
      },
    }),
    { name: 'ProfileStore' }
  )
);

interface GroupStore {
  primaryGroup: string;
  setPrimaryGroup: (newGroup: string) => void;
  clearPrimaryGroup: () => void;
}
export enum PrimaryGroups {
  Partner = "partner",
  Profile = "profile"
}
export const useGroupStore = create<GroupStore>()(
  persist(
    (set) => ({
      primaryGroup: "",
      setPrimaryGroup: (newGroup) => set({ primaryGroup: newGroup }),
      clearPrimaryGroup: () => {
        set({ primaryGroup: "" });
        localStorage.removeItem('GroupStore');
      },
    }),
    { name: 'GroupStore' }
  ),
);

interface RoleStore {
  customerRole: CustomerRoleName | null;
  setCustomerRole: (newRole: CustomerRoleName) => void;
  clearCustomerRole: () => void;
}

export enum CustomerRoleName {
  FreeServiceCustomer = 'FreeServiceCustomer',
  RetailCustomer = 'RetailCustomer',
  CoClientCustomer = 'CoClientCustomer',
  TaxPrepReferredCustomer = 'TaxPrepReferredCustomer',
  TaxReliefGraduatedCustomer = 'TaxReliefGraduatedCustomer',
  NonTaxPrepReferredCustomer = 'NonTaxPrepReferredCustomer'
}

export const useRoleStore = create<RoleStore>()(
  persist(
    (set) => ({
      customerRole: null,
      setCustomerRole: (newRole) => set({ customerRole: newRole }),
      clearCustomerRole: () => {
        set({ customerRole: null });
        localStorage.removeItem('RoleStore');
      },
    }),
    { name: 'RoleStore' }
  ),
);

export default useProfileStore;
